import * as React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

import { OutputArrowIcon } from '../../icons/Icons';

import { Pill } from './SharedStyles';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    color: ${({ theme }) => rgba(theme.highlightColor, 0.5)};
  }
`;

interface CellFooterProps {
  outputColor?: string;
  outputName: string;
}

export const CellFooter: React.ComponentType<CellFooterProps> = React.memo(
  ({ outputName, outputColor = 'green' }) => {
    const outputNames = outputName.split(',');

    return (
      <Wrapper>
        <OutputArrowIcon />
        {outputNames.map((item, index) => (
          <Pill key={index} $color={outputColor} $lightBkg={false}>
            {item}
          </Pill>
        ))}
      </Wrapper>
    );
  }
);
